import { createFileRoute } from '@tanstack/react-router'

import { CalcForm } from '@/features/calc/calc-form'

export const Route = createFileRoute('/_authed/calc')({
  component: CalcForm,
})
